module.exports = __webpack_public_path__ + "img/solution-tool-system-pic-10.17635f05.png";